import React from 'react'
import Link from 'gatsby-link'
import { css } from 'react-emotion'

const IndexPage = ({ data }) => (
  <div>
    <h1>Home Page</h1>
    <p>This is a placeholder website for Classroom League. We mainly host privacy policies for our various applications. We may also include various posts and updates for our applications.</p>
    <Link to="/privacy-policy">Privacy Policy</Link>
    <br/>
    <br/>
    <hr/>
    <h4>{data.allMarkdownRemark.totalCount} Posts</h4>
    {data.allMarkdownRemark.edges.map(({ node }) => (
      <div key={node.id}>
        <h3>
          {node.frontmatter.title}{" "}
          <span className={css`color: #bbb;`}>
            — {node.frontmatter.date}
          </span>
        </h3>
        <p>{node.excerpt}</p>
      </div>
    ))}
  </div>
)

export default IndexPage

export const query = graphql`
  query Posts {
    allMarkdownRemark {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
          }
          excerpt
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js